const svLocale = {
  dashboard: `Instrumentpanel`,
  engage: `Engagera`,
  assets: `Tillgångar`,
  submissions: `Inlämningar`,
  impact: `Inverkan`,
  programmes: `Program`,
  interactions: `Interaktioner`,
  donations: `Donationer`,
  impact_strategy: `Effektstrategi`,
  my_profile: `Min profil`,
  organisation: `Organisation`,
  users: `Användare`,
  profile: `Profil`,
  help: `Hjälp`,
  logout: `Utloggning`,
  insights: `Insikter`,
  data: `Data`,
  progress: `Framsteg`,
  ideas: `Idéer`,
  reviewed: `Recenserad`,
  in_progress: `Pågår`,
  pending_review: `Väntar på granskning`,
  most_popular_theme: `Mest populära temat`,
  local_resident: `Lokal invånare`,
  local_business: `Lokalt företag`,
  charitable_group: `Välgörenhetsgrupp`,
  other_stakeholder: `Andra intressenter`,
  cultural: `Kulturell`,
  environmental: `Miljö`,
  economic: `Ekonomisk`,
  educational: `Pedagogiska`,
  social: `Social`,
  responder_types: `Svarstyper`,
  most_popular_category: `Mest populära kategori`,
  green_spaces: `Gröna ytor`,
  local_tourism: `Lokal turism`,
  skills_development: `Kompetensutveckling`,
  other: `Andra`,
  most_popular_sub_category: `Mest populära underkategorin`,
  grassland: `Gräsmark`,
  burgers: `Hamburgare`,
  green_skills: `Gröna färdigheter`,
  filters: `Filter`,
  theme: `Tema`,
  category: `Kategori`,
  sub_category: `Underkategori`,
  ideas_by_phase: `Idéer efter fas`,
  oops: `hoppsan! Användarnamn/lösenord kan vara felaktigt`,
  forgot_password: `Glömt lösenordet?`,
  forgot_password_line1: `Om du har ett konto kommer du att ha fått ett "Återställ lösenord" e-post från BizGive Support. Följ länken i det e-postmeddelandet för att skapa ett nytt lösenord.`,
  forgot_password_line2: `Kontrollera även din skräppostmapp.`,
  forgot_password_line3: `Om du inte får ett e-postmeddelande kanske du inte har ett aktivt konto. Vänligen kontakta BizGive Support.`,
  forgot_password_header: `Kontrollera din inkorg`,
  incorrect_email_id: `Kontrollera e-postadressen du har angett.`,
  forget_password: `Glöm lösenord`,
  forget_password_hint: `Använd mer än 8 tecken, en stor och liten bokstav, en siffra och ett specialtecken.`,
  date_submitted: `Inlämningsdatum`,
  need: `Behov`,
  attributes: `Attribut`,
  happy_to_be_contacted: `Glad över att bli kontaktad?`,
  actions: `Åtgärder`,
  add_comment: `Lägg till kommentar`,
  date_actioned: `Åtgärdsdatum`,
  actioned_by: `Handlade av`,
  back_to_map: `Tillbaka till kartan`,
  submitter_type: `Typ av insändare`,
  submitter_location: `Avsändarens plats`,
  submission_location: `Inlämningsplats`,
  categories: `Kategorier`,
  yes: `Ja`,
  no: `Inga`,
  save: `Spara`,
  idea_location: `Idé plats`,
  please_populate: `Vänligen fyll i`,
  comments_added_successfully: `Kommentarer har lagts till`,
  see_location: `Se Plats`,
  feedback: `Feed-back`,
  feedback_by_phase: `Feedback per fas`,
  feedback_location: `Feedback Plats`,
  comment: `Kommentar`,
  asset: `Tillgång`,
  phase: `Fas`,
  idea: `Aning`,
  submitter: `Insändare`,
  requestedContact: `Begärd kontakt?`,
  collaborate: `Samarbeta`,
  contact_by_phase: `Kontakt per fas`,
  collaborate_location: `Samarbeta Plats`,
  number_of_employees: `Nej. Anställda`,
  global_annual_turnover: `Global årlig omsättning (£m)`,
  industry: `Industri`,
  services_provided: `Tjänster som tillhandahålls`,
  services_description: `Beskrivning av tjänster`,
  renewable_experience: `Förnybar upplevelse?`,
  requested_introduction_to_tier_one_contractors: `Begärt introduktion till Tier 1 Contractors?`,
  organization_name: `Organisationens namn`,
  website: `Webbplats`,
  overview: `Översikt`,
  total_visitors: `Totalt antal besökare`,
  feedback_submitted: `Feedback har skickats`,
  ideas_submitted: `Idéer inskickade`,
  collaborations_submitted: `Samarbeten inlämnade`,
  pending_actions: `Väntande åtgärder`,
  three_month_historical_visitors: `3 månaders historiska besökare`,
  submission_type: `Typ av inlämning`,
  collaborations: `Samarbeten`,
  applications: `Ansökningar`,
  action_required: `Åtgärd krävs`,
  pending_response: `Väntar på svar`,
  pre_approved: `Förhandsgodkänd`,
  approved: `Godkänd`,
  declined: `Avböjde`,
  your_session_will_expire_in: `Din session går ut om...`,
  select_whether_you_would_like_to_stay_logged_in_or_log_out: `Välj om du vill vara inloggad eller logga ut. Om du inte gör något kommer du automatiskt att loggas ut av säkerhetsskäl.`,
  stay_logged_in: `Håll dig inloggad`,
  log_out: `Logga ut`,
  all_phases: `Alla faser`,
  login: `Inloggning`,
  not_registered_yet: `Inte registrerad ännu?`,
  sign_up: `Registrera dig`,
  user_terms: `Användarvillkor`,
  privacy_policy: `Sekretesspolicy`,
  create_an_account_to_apply_for_support: `Skapa ett konto för att ansöka om support`,
  are_you_impact_funder_contact_us: `Är du en effektfinansiär? Kontakta oss`,
  confirm_password: `Bekräfta lösenord`,
  password_must_include: `Lösenordet måste innehålla:`,
  more_than_eight_characters: `- Mer än 8 tecken`,
  an_upper_and_lower_case_character: `- En stor och liten bokstäver`,
  a_number: `- Ett nummer`,
  a_special_character: `– En speciell karaktär`,
  i_accept_the: `Jag accepterar`,
  register: `Register`,
  connect_with_funders_and_design_your_opportunities_to_create_positive_impact: `Få kontakt med finansiärer och utforma dina möjligheter för att skapa positiv påverkan`,
  or_login_to_create_your_free_BizGive_account: `eller logga in för att skapa ditt kostnadsfria BizGive-konto.`,
  discover: `Upptäcka`,
  funding_programmes_and_create_a_profile_to_receive_alerts: `finansieringsprogram och skapa en profil för att ta emot varningar.`,
  submit: `Överlämna`,
  applications_auto_verified_against_funder_criteria: `ansökningar, automatiskt verifierade mot finansiärens kriterier.`,
  share: `Dela`,
  content_track_impact_and_capture_funder_feedback: `innehåll, spåra effekter och fånga feedback från finansiärer.`,
  here: `här`,
  please_enter_password: `Vänligen ange lösenord`,
  ok: `Ok`,
  confirm_email: `Bekräfta e-post`,
  log_in: `Logga in`,
  please_enter_email: `Vänligen ange e-post`,
  the_input_is_not_valid_email: `Inmatningen är inte giltig E-post!`,
  the_new_password_that_you_entered_do_not_match: `Det nya lösenordet du angav stämmer inte överens!`,
  the_new_email_that_you_entered_do_not_match: `Den nya e-postadressen du angav stämmer inte överens!`,
  please_confirm_your_password: `Vänligen ange Bekräfta lösenord`,
  please_accept_the_user_terms: `Vänligen acceptera användarvillkoren`,
  change_password: `Ändra lösenord`,
  password: `Lösenord`,
  we_just_emailed: `Vi har precis mailat`,
  please_click_on_the_link_in_your_email_to_activate_your_account: `Klicka på länken i din e-post för att aktivera ditt konto`,
  please_enter_a_valid_password: `Vänligen ange ett giltigt lösenord`,
  you_have_been_logged_out_due_to_inactivity: `Du har blivit utloggad på grund av inaktivitet...`,
  please_enter_a_valid_password_using_the_guidance_below: `Fel - Ange ett giltigt lösenord med hjälp av vägledningen nedan.`,
  entity: `Enhet`,
  media: `Media`,
  logo: `Logotyp`,
  profile_create: `Profil Skapa`,
  lets_get_started: `Låt oss komma igång`,
  name_and_location: `Namn och plats`,
  what_is_the_legal_Name_of_your_entity: `Vad är det juridiska namnet på din enhet?`,
  what_entity_name_would_like_to_be_displayed: `Vilket enhetsnamn skulle vilja visas?`,
  what_is_your_registered_address: `Vad är din folkbokförda adress?`,
  description: `Beskrivning`,
  add_your_description: `Lägg till din beskrivning`,
  add_your_social_media_details: `Lägg till dina sociala medier-detaljer`,
  what_is_your_website: `Vad är din hemsida?`,
  optional: `Frivillig`,
  add_your_company_logo: `Lägg till din företagslogotyp`,
  upload: `Ladda upp`,
  organization_profile: `Organisationsprofil`,
  description_company: `Beskrivning`,
  detail: `Detalj`,
  registered_address: `Registrerad adress`,
  proceed: `Fortsätta`,
  previous: `Tidigare`,
  save_n_exit: `Spara och avsluta`,
  next: `Nästa`,
  enter: `Skriva in`,
  complete: `Komplett`,
  my_details: `Mina detaljer`,
  your_name: `Ditt namn`,
  phone_number: `Telefonnummer`,
  job_title: `Arbetstitel`,
  biz_give_role: `BizGive roll`,
  member_since: `Medlem sedan dess`,
  my_programmes: `Mina program`,
  delete_file_confirmation: `Ta bort filbekräftelse`,
  please_confirm_you_are_happy_to_permanently_delete_this_file: `Bekräfta att du gärna vill ta bort den här filen permanent?`,
  delete: `Radera`,
  cancel: `Avboka`,
  create_password: `Skapa lösenord`,
  invite_new_user: `Bjud in ny användare`,
  regular_users: `Regelbundna användare`,
  can_not_view_or_edit_anything_by_default: `kan inte visa eller redigera något som standard. Alla inbjudna användare börjar med denna status. Du kan lägga till dem i Program för att visa och eller redigera det specifika programmet och relaterat innehåll.`,
  organization_admins: `Organisationsadministratörer`,
  can_access_and_edit_everything_in_the_platform: `kan komma åt och redigera allt på plattformen. Du kan tilldela befintliga användare med denna behörighet på den här skärmen.`,
  user_name: `Användarnamn`,
  make_admin: `Gör admin`,
  remove_admin: `Ta bort admin`,
  invited: `INBJUDAD`,
  regular: `REGELBUNDEN`,
  admin: `ADMINISTRATION`,
  remove_user_from_your_organization: `Ta bort användare från din organisation`,
  please_confirm_you_are_to_permanently_remove_this_user: `Bekräfta att du ska ta bort den här användaren permanent?`,
  none_of_their_programmes_or_interaction_data_will_be_removed: `Inget av deras program eller interaktionsdata kommer att tas bort`,
  remove_user: `Ta bort användare`,
  remove_admin_rights: `Ta bort administratörsrättigheter`,
  remove: `Ta bort`,
  as_an_Organization_Admin: `som organisationsadministratör.`,
  they_will_then_only_be_able_to_view_and_edit_programmes_that_they_manage: `De kommer då bara att kunna se och redigera program som de hanterar.`,
  enter_email_address: `Ange e-postadress`,
  confirm_email_address: `Bekräfta e-postadress`,
  invite: `Bjuda`,
  add_admin_rights: `Lägg till administratörsrättigheter`,
  make: `Göra`,
  an_organization_admin: `en organisationsadministratör`,
  they_will_be_able_to_view_and_edit_everything_in_your_organization: `De kommer att kunna se och redigera allt i din organisation.`,
  charity_can_not_view_or_edit_anything_by_default: `kan inte visa eller redigera något som standard. Alla inbjudna användare börjar med denna status. Du kan lägga till dem i applikationer för att visa och eller redigera den specifika applikationen och relaterat innehåll.`,
  charity_can_access_and_edit_everything_in_the_platform: `kan komma åt och redigera allt på plattformen. Du kan tilldela befintliga användare med denna behörighet på den här skärmen.`,
  none_of_their_applications_or_interaction_data_will_be_removed: `Ingen av deras applikationer eller interaktionsdata kommer att tas bort`,
  they_will_then_only_be_able_to_view_and_edit_applications_that_they_manage: `De kommer då bara att kunna se och redigera applikationer som de hanterar.`,
  the_invited_user_already_has_an_account_linked_to_this_email_address: `Den inbjudna användaren har redan ett konto kopplat till den här e-postadressen. Kontrollera din användarlista eller kontakta BizGive för support.`,
  all_programmes: `Alla program`,
  download: `Ladda ner`,
  search_placeholder: `Söka...`,
  actions_required: `Åtgärder som krävs`,
  opportunity: `Möjlighet`,
  date_applied: `Datum tillämpat`,
  date_requested: `Datum begärt`,
  net_vote: `Netto röst (väljare)`,
  date_approved: `Godkänt datum`,
  date_declined: `Avvisat datum`,
  applied: `TILLÄMPAD`,
  in_edit: `I EDIT`,
  pre_approved_caps: `FÖRGODKÄND`,
  approved_caps: `GODKÄND`,
  declined_caps: `AVSLAGDE`,
  review: `Recension`,
  customize_your_download: `Anpassa din nedladdning`,
  select_application_status: `Välj Applikationsstatus`,
  share_and_manage_voting: `Dela och hantera röstning`,
  current_share_access_closing_date: `Aktuellt slutdatum för aktieåtkomst`,
  invited_users_will_receive_an_email_with_access_details: `Inbjudna användare kommer att få ett e-postmeddelande med åtkomstdetaljer, tillgängliga fram till sista datum. De kommer bara att kunna se sina röster.`,
  invited_voters: `Inbjudna väljare`,
  add_email_address: `Lägg till e-postadress`,
  reported_grants: `Anmälda bidrag`,
  planned_grants: `Planerade bidrag`,
  remaining_budget: `Återstående budget`,
  total_budget: `Total budget`,
  do_you_wish_to_request_indicators: `Vill du begära indikatorer?`,
  the_entity_will_be_asked_to_create: `Entiteten kommer att bli ombedd att skapa indikatorer för sina möjligheter anpassade till utvalda resultat.`,
  please_confirm_you_wish_to_complete_this_item: `Detta steg är klart.`,
  requested: `Begärde`,
  do_you_wish_the_applicant_to_create_indicators_to_measure_its_progress: `Vill du att den sökande ska skapa indikatorer för att mäta dess framsteg?`,
  volunteering: `Volontärarbete`,
  day: `Dag`,
  inkind: `In natura`,
  budget_period_end: `Budgetperiod slut`,
  budget_available: `Budget tillgänglig`,
  budget_amount: `Budgetbelopp`,
  remaining: `Återstående`,
  select_filter: `Välj ett filter`,
  donation_title: `Donation`,
  email_id_title: `E-post-ID`,
  add_user: `Lägg till användare`,
  delete_title: `Radera`,
  add_title: `Tillägga`,
  delete_user: `Ta bort användare`,
  action_cannot_undone: `Denna åtgärd kan inte ångras. Alla möjligheter som de hanterar kommer fortfarande att vara tillgängliga för kontoadministratörer.`,
  confirm_title: `Bekräfta`,
  adding_admin_rights: `Att lägga till administratörsrättigheter ger möjlighet för användaren att skapa möjligheter, uppdatera organisationsprofilen, lägga till och ta bort användare och skapa administratörer.`,
  remove_admin_rights_para: `Ta bort administratörsrättigheter, tar bort möjligheten för användaren att skapa möjligheter, uppdatera organisationsprofilen, lägga till och ta bort användare och skapa administratörer.`,
  save_private: `Sparad (privat)`,
  planned_shared: `Planerad (delad)`,
  invoice_requested: `Faktura begärd`,
  invoice_received: `Faktura mottagen`,
  reported_title: `Rapporterad`,
  confirmed_title: `Bekräftad`,
  report_donation: `Anmäl donation`,
  cancel_title: `Avboka`,
  save_title: `Spara`,
  grant: `Bevilja`,
  awarded: `Tilldelas`,
  award_title: `Tilldela`,
  type_title: `Typ`,
  invoice_title: `Faktura`,
  condition_title: `Skick`,
  reported_date_title: `Rapporterat datum`,
  next_action_title: `Nästa åtgärd`,
  donation_created: `Framgång – donation skapad`,
  donation_updated: `Framgång – donation uppdaterad`,
  donation_deleted: `Framgång – donation raderad`,
  view_donation: `Visa donation`,
  select_title: `Välja`,
  approved_opportunities_planned_impact: `Godkända möjligheter (planerad effekt)`,
  achieved_impact: `Uppnådd effekt (avslutade möjligheter)`,
  achieved_beneficiaries: `Uppnådda förmånstagare`,
  outputs_achieved: `Utgångar uppnådda`,
  content_received: `Mottaget innehåll (uppnådd effekt)`,
  opportunity_name: `Möjlighetens namn`,
  entity_name: `Entitetsnamn`,
  due_date: `Förfallodatum`,
  number: `Antal`,
  approved_date: `Godkänt datum`,
  view: `Se`,
  primary_UN_SDG: `Primärt FN:s SDG `,
  opportunity_type: `Möjlighetstyp`,
  charity_name: `Välgörenhetsnamn`,
  select_type: `Välj en typ`,
  please_fill_amount: `Vänligen fyll i belopp`,
  enter_title: `Skriva in`,
  please_enter_conditions: `vänligen ange skick`,
  please_select_action: `Välj en åtgärd`,
  actions_title: `Åtgärder`,
  select_action: `Välj Åtgärd`,
  payment_reference: `Betalningsreferens`,
  please_select_amount: `Välj ett belopp`,
  enter_payment_reference: `Ange betalningsreferens`,
  upload_counterpart_behalf: `Ladda upp faktura på uppdrag av motpart`,
  equivalent_value: `Motsvarande värde`,
  amount_title: `Belopp`,
  purchase_order: `Inköpsorder`,
  files_title: `Filer`,
  company_name_title: `Företagsnamn`,
  programme_type_title: `Programtyp`,
  application_start_date: `Ansökans startdatum`,
  application_end_date: `Ansökans slutdatum`,
  location_title: `Plats`,
  next_update_outcome: `Nästa uppdatering/resultat`,
  donations_by: `Donationer av`,
  decision_date: `Beslutsdatum`,
  decision_start_date: `Startdatum för beslut`,
  decision_end_date: `Slutdatum för beslut`,
  opportunity_i_manage: `Möjligheter jag förvaltar`,
  select_template: `Välj Mall`,
  please_select_template: `Välj en mall`,
  save_draft: `Spara utkast`,
  all_opportunities: `Alla möjligheter`,
  excel_title: `Excel`,
  round: `Runda`,
  select_donation_status: `Välj Donationsstatus`,
  delete_file: `Ta bort fil`,
  deleting_file_para: `Om du tar bort den här filen tas den bort permanent`,
  delete_donation: `Ta bort donation`,
  delete_donation_para: `Om du tar bort denna donation kommer all relaterad information att tas bort permanent`,
  cancel_changes: `Avbryt ändringar`,
  remove_title: `Ta bort`,
  will_remove_changes_to_donation: `Detta tar bort alla ändringar som gjorts i donationen`,
  edit_title_uppercase: `REDIGERA`,
  current_report_period: `Aktuell rapportperiod`,
  current_report_open: `Aktuell rapport öppen`,
  current_report_close: `Aktuell rapport Stäng`,
  manage_title: `Hantera`,
  open_date: `Öppet datum`,
  close_date: `Stängningsdatum`,
  period_title: `Period`,
  reporter_title: `Reporter`,
  edit_title: `Redigera`,
  about_me: `Om mig`,
  please_enter_valid_name: `Vänligen ange ett giltigt namn`,
  please_enter_only_alphabets: `Ange endast alfabet`,
  name_Title: `Namn`,
  phone_number_title: `Telefonnummer`,
  upload_purchase_order: `Ladda upp inköpsorder`,
  programme_dates: `Programdatum`,
  programme_start: `Programstart`,
  programme_end: `Program slut`,
  currency: `Valuta`,
  current_budget_year_end: `Nuvarande budget årsslut:`,
  approved_summary: `Godkänd sammanfattning`,
  please_select_programme: `Välj ett program`,
  generate: `Generera`,
  opportunities_supported: `Möjligheter som stöds`,
  approved_opportunities: `Godkända möjligheter`,
  planned_impact: `Planerad påverkan (godkända möjligheter)`,
  grants: `Bidrag`,
  planned_beneficiaries: `Planerade förmånstagare`,
  direct: `Direkt`,
  indirect: `Indirekt`,
  primary: `Primär`,
  secondary: `Sekundär`,
  all: `Alla`,
  programme_name: `Programnamn`,
  reset: `Återställa`,
  my_feedback: `Min feedback`,
  feedback_title: `Feed-back`,
  select_opportunity: `Välj Möjlighet`,
  please_select_opportunity: `Välj en möjlighet`,
  select_report: `Välj Rapportera`,
  please_select_report: `Välj en rapport`,
  editing_title: `Redigering`,
  enabled_title: `Aktiverad`,
  locked_title: `Låst`,
  content_title_uppercase: `INNEHÅLL`,
  feedback_title_uppercase: `FEED-BACK`,
  no_data: `Inga data`,
  program_status: `Programstatus`,
  un_sdgs: `FN:s SDG`,
  more_title: `Mer`,
  program_location: `Programplats`,
  asset_name: `Tillgångens namn`,
  asset_location: `Tillgångsplats`,
  portfolio_title: `Portfölj`,
  review_title: `Recension`,
  payment_date: `Betalningsdatum`,
  secondary_UN_SDG: `Sekundära FN-mål`,
  summary_title: `Sammanfattning`,
  select_the_programme_you_wish_to_receive: `Välj det program du vill få en rapport för på tillgången som valts ovan.`,
  manager: `Chef`,
  add_managers_who_can_invite_reporter: `Lägg till chefer som kan bjuda in reportrar å dina vägnar. Obs! Interna användare från din organisation kan läggas till från din`,
  admin_page: `admin sida`,
  inviting_existing_user: `Bjuder in befintlig användare`,
  invite_new: `Bjud in nya`,
  external_users: `externa användare`,
  by_entering_their_email_address: `genom att ange deras e-postadress`,
  optional_add_reporters: `Frivillig. Lägg till reportrar som kommer att slutföra programrapporter för dina tillgångar.`,
  manage_report: `Hantera rapport`,
  add_asset: `Lägg till tillgång`,
  budget_history: `Budget Historia`,
  milestones: `Milstolpar`,
  programme_name_title: `Programnamn`,
  application: `Ansökan`,
  create: `Skapa`,
  comment_title: `Kommentar`,
  cash_donation_saved_successfully: `Kontantdonation sparad.`,
  upload_invoice: `Ladda upp faktura`,
  upload_title: `Ladda upp`,
  confirm_receipt: `Bekräfta mottagandet`,
  received_title: `Mottagen`,
  please_confirm_donation_received: `Vänligen bekräfta att denna donation har tagits emot.`,
  success_donation_received: `Framgång - donation mottagen`,
  success_invoice_uploaded: `Framgång – faktura laddad upp`,
  click_to_upload: `Klicka för att ladda upp`,
  settings: `Inställningar`,
  internal_only: `Endast internt`,
  visibility_title: `Synlighet`,
  public_title: `Offentlig`,
  private: `Privat`,
  completed: `Avslutad`,
  content_package: `Innehållspaket`,
  please_select_interaction_status: `Välj interaktionsstatus.`,
  go_back: `Gå tillbaka`,
  budget_dates: `Budgetdatum`,
  budget_recurring: `Budget återkommande?`,
  objectives: `Mål`,
  supporting_materials: `Stödmaterial`,
  web_links: `Webblänkar`,
  administrators: `Administratörer`,
  application_criteria: `Ansökningskriterier`,
  documentation_required: `Dokumentation krävs`,
  available_support: `Tillgänglig support`,
  none: `Ingen`,
  eligibility_checklist: `Kvalificeringschecklista`,
  location_supported: `Plats stöds`,
  project_must_be_within: `Projektet måste vara inom`,
  of_this_location: `av denna plats`,
  expand_all: `Expandera alla`,
  entities_supported: `Enheter som stöds`,
  mandatory: `Obligatorisk`,
  expected_budget: `Förväntad budget`,
  per_opportunity: `Per tillfälle`,
  specific_skills_available: `Specifik färdighet tillgänglig`,
  general_skills_available: `Allmänna färdigheter tillgängliga`,
  any: `Några`,
  application_accepted_between: `Ansökan accepteras mellan kl`,
  donation_to_be_made_between: `Donation att göras mellan`,
  interim_update_requested: `Interimsuppdatering begärd`,
  final_report_requested: `Slutrapport begärd`,
  show_all_goals: `Visa alla mål`,
  any_location: `Vilken plats som helst`,
  apply: `Tillämpas`,
  eligibility: `Behörighet`,
  before_applying_please_confirm_your_eligibility: `Innan du ansöker, bekräfta att du är behörig:`,
  please_confirm_that_your_project_is_located_within_or_that_it_benefits_those_within_the_supported_locations: `Bekräfta att ditt projekt ligger inom eller att det gynnar dem inom de stödda platserna.`,
  please_select: `Vänligen välj`,
  project_description: `Projektbeskrivning`,
  please_share_a_summary_of_your_project: `Dela gärna en sammanfattning av ditt projekt`,
  enter_project_summary: `Ange projektsammanfattning`,
  please_describe_your_project: `Beskriv ditt projekt`,
  for_example_what_do_you_want_to_do: `Till exempel, vad vill du göra, hur ska du göra detta, har du identifierat ett behov av projektet och vem ska leda det?`,
  this_application_is_to: `Denna ansökan är till:`,
  application_accepted: `Godkända ansökningar:`,
  application_sections: `Applikationssektioner`,
  application_preview: `Förhandsgranskning av applikationen`,
  application_guidance: `Ansökningsvägledning`,
  in_the_application_form: `I ansökningsformuläret kommer du att bli ombedd att dela information om ett projekt du ansöker om finansiering för.`,
  next_title: `'Nästa'`,
  save_n_exit_title: `"Spara och avsluta"`,
  submit_title: `'Överlämna'`,
  saves_your_data_and_moves: `sparar dina data och flyttar dig till nästa skärm i ansökningsformuläret. Dina svar sparas automatiskt om du inte har problem med internetanslutningen.`,
  saves_your_data_and_closes: `sparar dina uppgifter och stänger ansökningsformuläret så att du kan återvända till senare. Du måste fylla i alla obligatoriska fält för att "Spara och avsluta" (du kan lägga in slumpmässiga värden t.ex. X som platshållare, för att cl.`,
  sends_your_application_form_to_the_company: `skickar din ansökningsblankett till företaget. Denna knapp visas på den sista skärmen i ansökningsformuläret.`,
  to_access_a_saved_application: `För att komma åt en sparad applikation: Klicka på Applications and Action Required.`,
  to_view_a_submitted_application: `För att se en inskickad ansökan: Klicka på Ansökningar och väntar på svar`,
  start: `Start`,
  application_form: `Ansökningsformulär`,
  your_application: `Din ansökan`,
  what_is_the_name_of_your_project: `Vad heter ditt projekt?`,
  please_complete_each_screen: `Fyll i varje skärm i ansökningsformuläret. På den sista skärmen ser du en förhandsgranskning av din ansökan och härifrån kan du klicka på "Skicka" för att skicka den till företaget.`,
  project_name: `Projektnamn`,
  add_a_banner_image: `Lägg till en bannerbild`,
  this_will_show_at_the_top_of_your_application_form: `Detta kommer att visas högst upp i din programprofil.`,
  choose_an_image_from_bizGive: `Välj en bild från BizGive`,
  upload_your_own_banner_image: `Ladda upp din egen bannerbild`,
  additional_images: `Ytterligare bilder`,
  bizGive_images: `BizGive bilder`,
  where_is_your_project_located: `Var ligger ditt projekt?`,
  search_for_and_select_the_address_of_your_location: `Sök efter och välj adressen till dina platser. Eller alternativt,`,
  click: `klick`,
  any_place_or_point_on_the_map_to_select_it: `valfri plats eller punkt på kartan för att välja den.`,
  add_or_Edit_the_name_for_your_location_and_press: `Lägg till eller redigera namnet för din plats och tryck på "Lägg till en annan" för att lägga till fler platser.`,
  add_additional_location: `Lägg till ytterligare plats`,
  one_or_more_project_locations_are_located_outside_of_the_programme_area: `En eller flera projektorter finns utanför programområdet.`,
  please_change_your_project_location_or_explain_how_your_project_will_benefit_the_programme_area_below: `Vänligen ändra din projektplats ELLER förklara hur ditt projekt kommer att gynna programområdet nedan`,
  how_will_it_benefit_the_programme_area: `Hur kommer det att gynna programområdet?`,
  project_dates: `Projektdatum`,
  when_is_your_project_happening: `När pågår ditt projekt?`,
  this_can_be_an_estimate: `Detta kan vara en uppskattning, eftersom du kommer att bli ombedd att redigera eller bekräfta dina datum om din ansökan är framgångsrik.`,
  projects_must_start_within_12_months: `Projekt måste starta inom opportunityStart WithinMonths månader.`,
  projects_must_not_be_longer_than_6_months: `Projekt får inte vara längre än opportunityLengthMonths månader.`,
  estimated_start: `Beräknad start`,
  estimated_finish: `Beräknad finish`,
  is_there_a_deadline_when_you_need_to_receive_a_donation_by: `Finns det en deadline när du behöver ta emot en donation senast, för att ditt projekt ska kunna gå vidare?`,
  if_not_please_leave_this_blank: `Om inte, lämna detta tomt.`,
  enter_date: `Ange datum`,
  what_support_are_you_applying_for: `Vilket stöd ansöker du om?`,
  in_kind: `In natura`,
  how_much_are_you_applying_for: `Hur mycket ansöker du om?`,
  enter_amount: `Ange belopp`,
  how_much_does_your_project_cost_in_total: `Hur mycket kostar ditt projekt totalt?`,
  you_are_applying_for_percentage_of_the_total_cost_of_your_project: `Du ansöker om en procentandel av den totala kostnaden för ditt projekt`,
  how_will_you_use_any_support_awarded: `Hur kommer du att använda eventuellt stöd?`,
  enter_number_of_items_or_activity: `Ange antalet objekt eller aktivitet`,
  enter_description: `Ange beskrivning`,
  where_will_additional_funds_come_from: `Var kommer ytterligare medel ifrån?`,
  internal_resources: `Interna resurser`,
  external_funding: `Extern finansiering`,
  have_you_already_secured_this_funding: `Har du redan säkrat denna finansiering?`,
  can_your_project_proceed_if_you: `Kan ditt projekt fortsätta om du inte säkrar denna extra finansiering?`,
  what_outputs_will_the_support_help_you_to_achieve: `Vilka resultat kommer stödet att hjälpa dig att uppnå?`,
  your_outputs_will_show_like_this_in_your_application_form: `Dina utdata kommer att visas så här i ditt ansökningsformulär:`,
  what_items_or_services_do_you_need: `Vilka varor eller tjänster behöver du?`,
  for: `för`,
  what_volunteering_support_do_you_need: `Vilket volontärstöd behöver du?`,
  edit_image: `Redigera bild`,
  change_image: `Ändra bild`,
  delete_image: `Ta bort bild`,
  click_delete_to_remove_this_image: `Klicka på "Ta bort" för att ta bort den här bilden.`,
  option: `Alternativ`,
  add: `Tillägga`,
  tips: `Tips`,
  what_is_an_output: `Vad är en utgång?`,
  an_output_is_what_you_expect_to_achieve_from_the_support_awarded_below_are_some_examples: `En output är vad du förväntar dig att uppnå av det tilldelade stödet. Nedan följer några exempel:`,
  number_new_teaching_assistants_trained: `5 nya lärarassistenter utbildade`,
  number_new_teachers_trained: `10 nya lärare utbildade`,
  number_workshops_hosted: `3 workshops värd`,
  number_energy_audits_completed: `4 energibesiktningar genomförda`,
  number_people_more_aware_of_climate_change_in_our_community: `200 personer mer medvetna om klimatförändringarna i vårt samhälle`,
  number_new_playground_installed: `1 ny lekplats installerad`,
  please_enter: `Vänligen ange`,
  which_of_the_company_impact_objectives_will_your_project_support: `Vilka av företagets effektmål kommer ditt projekt att stödja?`,
  what_outcomes_do_you_hope_your_project_will_achieve: `Vilka resultat hoppas du att ditt projekt ska uppnå?`,
  what_is_an_outcome: `Vad är ett resultat?`,
  an_outcome_is_the_change_you_hope_to_see_as_a_result_of_your_project_below_are_some_examples: `Ett resultat är den förändring du hoppas se som ett resultat av ditt projekt. Nedan följer några exempel.`,
  objective_protect_and_improve_the_local_environment: `Mål: Skydda och förbättra den lokala miljön`,
  outcome_improve_fish_populations_through_river_restoration: `Resultat: Förbättra fiskpopulationer genom flodrestaurering.`,
  objective_create_and_improve_local_amenities: `Mål: Skapa och förbättra lokala bekvämligheter`,
  outcome_improve_the_energy_efficiency_of_the_village_hall_with_new_windows: `Resultat: Förbättra energieffektiviteten i kommunhuset med nya fönster.`,
  objective_engage_the_local_community: `Mål: Engagera lokalsamhället`,
  outcome_reduce_isolation_and_loneliness_in_older_people: `Resultat: Minska isolering och ensamhet hos äldre.`,
  how_will_you_achieve_these_outcomes: `Hur kommer du att uppnå dessa resultat?`,
  briefly_describe_your_approach_to_achieving_the_outcomes: `Beskriv kortfattat din metod för att uppnå resultaten.`,
  below_are_some_examples: `Nedan följer några exempel:`,
  we_will_remove_excess_silt: `Vi kommer att ta bort överflödigt silt, så att fiskens häckningsplatser återställs.`,
  we_will_replace_our_old_windows_with_triple_glazed_windows: `Vi kommer att byta ut våra gamla fönster till treglasfönster.`,
  we_will_run_weekly_workshops_bringing_older_people_together: `Vi kommer att hålla veckovisa workshops för att samla äldre människor.`,
  how_will_you_achieve_this_outcome: `Hur kommer du att uppnå detta resultat?`,
  please_use_no_more_than_25_words_as_you_will_be_asked_to_describe_your_approach_on_the_next_screen: `Använd inte mer än 25 ord eftersom du kommer att bli ombedd att beskriva ditt tillvägagångssätt på nästa skärm.`,
  enter_outcome: `Ange resultat`,
  please_enter_numeric_value: `Ange ett numeriskt värde`,
  expected_decision_date: `Förväntat beslutsdatum`,
  beneficiaries: `Förmånstagare`,
  who_or_what_will_benefit_from_your_project: `Vem eller vilka kommer att dra nytta av ditt projekt?`,
  who_are_the_social_beneficiaries: `Vilka är de sociala förmånstagarna?`,
  select_beneficiary_type: `Välj förmånstagaretyp`,
  how_many_people_will_benefit: `Hur många människor kommer att gynnas?`,
  direct_beneficiaries: `Direkta förmånstagare`,
  enter_estimated_number: `Ange uppskattat antal`,
  indirect_beneficiaries: `Indirekta förmånstagare`,
  how_will_the_environment_benefit: `Hur kommer miljön att gynnas?`,
  for_example_species_of_new_plants_introduced_ppm_of_CO2_reduced_terrestrial_animals_protected: `Till exempel introducerade 10 arter av nya växter, 10 ppm CO2 reducerad, 10 landlevande djur skyddade.`,
  select_type_title: `Välj Typ`,
  select_sub_type: `Välj Undertyp`,
  select_units: `Välj Enheter`,
  your_environmental_beneficiaries_will_show_like_this_in_your_application_form: `Dina miljöförmånstagare kommer att visa så här i ditt ansökningsformulär:`,
  environmental_beneficiaries: `Miljöförmånstagare`,
  the_environmental_beneficiaries_drop_down_fields_enable_you_to_share_additional_details: `Rullgardinsfälten för miljöförmåner gör att du kan dela ytterligare information, till exempel om du stöder arter, livsmiljöer eller byggnader, växter eller djur och vilka åtgärder du gör `,
  select_type_title_head: `Välj typ:`,
  choose_whether_your_project_supports_habitats_such_as_forests_or_woodlands: `Välj om ditt projekt stöder livsmiljöer, som skogar eller skogsmarker, arter, som växter eller djur, eller byggnader, som skolor eller gemensamma samhällsbyggnader, som ett byhus.`,
  select_sub_type_head: `Välj undertyp:`,
  choose_the_type_of_habitat_species_or_building_you_are_supporting: `Välj vilken typ av livsmiljö, art eller byggnad du stödjer. Välj till exempel sötvatten om du stödjer floder eller sjöar.`,
  select_action_head: `Välj åtgärd:`,
  choose_the_type_of_action_you_re_taking_to_support_the_species: `Välj vilken typ av åtgärd du vidtar för att stödja arten, livsmiljön eller byggnaden. Välj till exempel skyddad om du skyddar hotade arter, återställ om du återskapar en livsmiljö`,
  enter_amount_head: `Ange belopp:`,
  for_species_estimate_how_many_plants_or_animals_you_re_supporting_through_your_project: `För arter, uppskatta hur många växter eller djur du stödjer genom ditt projekt.`,
  for_habitats_estimate_how_many_habitats_you_re_supporting_number_or_the_total_area_in_hectares: `För livsmiljöer, uppskatta hur många livsmiljöer du stödjer (antal) eller den totala ytan (i hektar).`,
  for_buildings_estimate_how_many_buildings_you_re_supporting: `För byggnader, uppskatta hur många byggnader du stödjer (antal) eller hur mycket du minskar energi, vatten eller växthusgaser (ton CO2-ekvivalenter (CO2e)).`,
  select_units_head: `Välj enheter:`,
  number_is_an_estimate_of_the_total_number_of_habitats_species_or_buildings_you_plan_to_support: `Antal är en uppskattning av det totala antalet livsmiljöer, arter eller byggnader du planerar att stödja.`,
  hectares_is_an_estimate_of_the_total_area_of_a_habitat_youre_supporting: `Hektar är en uppskattning av den totala arean av en livsmiljö du försörjer.`,
  social_beneficiaries: `Sociala förmånstagare`,
  select_the_type_of_beneficiaries_your_project_supports: `Välj vilken typ av stödmottagare ditt projekt stödjer. Beräkna sedan det totala antalet förmånstagare som du planerar att stödja för alla typer av stödmottagare.`,
  direct_beneficiaries_head: `Direkta förmånstagare:`,
  the_number_of_people_who_directly_benefit_from_your_opportunity: `Antalet personer som direkt drar nytta av din möjlighet.`,
  indirect_beneficiaries_head: `Indirekta förmånstagare:`,
  the_number_of_people_whose_benefits_can_be_attributed_to_a_direct_beneficiary: `Antalet personer vars förmåner kan hänföras till en direkt förmånstagare.`,
  for_example_if_your_project_supports_children_with_learning_disabilitie: `Till exempel, om ditt projekt stödjer 10 barn med inlärningssvårigheter, är de direkta förmånstagarna de 10 barnen. De indirekta förmånstagarna är familjerna till dessa barn.`,
  habitats: `Habitater`,
  forest: `Skog`,
  deserts: `Öken`,
  mountains: `Fjäll`,
  coastal: `Kust`,
  marine: `Marin`,
  freshwater: `Sötvatten`,
  polar: `Polär`,
  wetlands: `Våtmarker`,
  rainforest: `Regnskog`,
  arctic: `Arktis`,
  tundra: `Tundra`,
  restored: `Återställd`,
  protected: `Skyddad`,
  created: `Skapad`,
  hectares: `Hektar`,
  established: `Etablerad`,
  benefitted: `Fördelats`,
  terrestrial_animals: `Landlevande djur`,
  aquatic_animals: `Vattenlevande djur`,
  terrestrial_plants: `Landlevande växter`,
  aquatic_plants: `Vattenväxter`,
  species: `Art`,
  select_category: `Välj kategori`,
  select_sub_category: `Välj underkategori`,
  please_add_at_least_one_outcome_under_selected_objectives: `Lägg till minst ett resultat under valda mål`,
  please_enter_your_approach_for_each_outcome: `Ange ditt tillvägagångssätt för varje resultat`,
  create_n_manage_sharing: `Skapa och hantera delning`,
  access_closing_date: `Sista datum för åtkomst`,
  please_choose_closing_date: `Vänligen välj Slutdatum`,
  newly_invited_users_will_receive_an_email_invitation: `Nyinbjudna användare kommer att få en e-postinbjudan.`,
  existing_invited_users_will_not_be_notified_of_changes: ` Befintliga inbjudna användare kommer inte att meddelas om ändringar.`,
  update: `Uppdatera`,
  user_already_exists: `Användaren finns redan`,
  verify_your_email: `Verifiera din e-post`,
  please_verify_your_email_to_receive_a_magic_link: `Verifiera din e-post för att få en magisk länk för att komma åt din feedbackportal.`,
  emissions: `Utsläpp`,
  greenhouse_gases: `Växthusgaser`,
  reduced: `Nedsatt`,
  captured: `Fångad`,
  prevented: `Förhindras`,
  tonnes_of_CO2_equivalents_C02e: `Ton CO2-ekvivalenter (C02e)`,
  additional_questions: `Ytterligare frågor`,
  required_documents: `Nödvändiga dokument`,
  document_name: `Dokumentnamn`,
  custom_question: `Anpassad fråga?`,
  enter_answer: `Ange svar`,
  if_you_are_awarded_support_you_may_be_required_to_share_interim_Updates: `Om du tilldelas stöd kan du bli tvungen att dela delårsuppdateringar och en engångsrapport med företaget. Du kommer att få ett e-postmeddelande från BizGive om och när dessa förfaller.`,
  can_you_meet_the_required_submission_deadlines: `Kan du hålla de angivna tidsfristerna för inlämning?`,
  based_on_the_estimated_start_and_finish_date_of_your_project: `Baserat på det beräknade start- och slutdatumet för ditt projekt, bekräfta att du kan hålla tidsfristerna för inlämning nedan. Du kommer att kunna uppdatera dina projektdatum om din ansökan är ca`,
  interim_updates: `Interimistiska uppdateringar`,
  final_report: `Slutrapport`,
  this_value_cannot_be_lower_than_the_amount_you_are_applying_for: `Detta värde kan inte vara lägre än det belopp du ansöker om`,
  what_is_an_interim_update: `Vad är en interimsuppdatering?`,
  an_update_required_by_the_company_on_the_progress_of_your_project: `En uppdatering som krävs av företaget om framstegen i ditt projekt.`,
  download_interim_update_report_template: `Ladda ner mall för interimsuppdateringsrapport`,
  what_is_a_final_report: `Vad är en slutrapport`,
  a_single_report_required_by_the_company_on_what_your_project_achieved_with_the_support_provided: `En enda rapport som krävs av företaget om vad ditt projekt uppnådde med det stöd som tillhandahålls.`,
  download_final_report_template: `Ladda ner mall för slutrapport`,
  how_will_i_know_when_an_interim_update_or_final_report_is_due: `Hur vet jag när en delårsuppdatering eller slutrapport ska lämnas?`,
  you_will_receive_an_email_notification_from_bizGive_when_the_deadline_is_approaching: `Du kommer att få ett e-postmeddelande från BizGive när deadline närmar sig. Följ instruktionerna i dessa e-postmeddelanden för att slutföra och skicka dessa rapporter till företaget.`,
  contact_details: `Kontaktuppgifter`,
  after_submitting_your_application_you_will_receive_email_notifications_from_BizGive_on_its_status: `När du har skickat in din ansökan kommer du att få e-postmeddelanden från BizGive om dess status.`,
  please_add_another_contact_in_case_of_your_absence: `Vänligen lägg till en annan kontakt vid din frånvaro.`,
  if_theyre_already_on_BizGive_select_their_name_below: `Om de redan är på BizGive, välj deras namn nedan:`,
  invite_a_colleague_to_join_by_entering_their_email_address_below: `Bjud in en kollega att gå med genom att ange deras e-postadress nedan:`,
  select_user: `Välj Användare`,
  what_is_an_indicator: `Vad är en indikator?`,
  an_indicator_is_a_measure_of_progress: `En indikator är ett mått på framsteg. Den innehåller ett mål och milstolpar för att nå detta mål. Till exempel antalet personer du planerar att hjälpa och hur detta kommer att öka över tiden.`,
  an_indicator_is_an_estimate: `En indikator är en uppskattning, så oroa dig inte om dina planer ändras. Om din ansökan godkänns kommer du att bli ombedd att uppdatera dina indikatorer.`,
  indicator_examples: `Indikatorexempel`,
  no_of_people_gaining_a_new_skill_or_qualification: `Antal personer som får en ny färdighet eller kvalifikation`,
  no_of_workshops_hosted: `Antal workshops värd`,
  decrease_in_local_unemployment: `% minskning av lokal arbetslöshet`,
  when_do_i_update_my_indicators: `När uppdaterar jag mina indikatorer?`,
  if_your_application_is_approved: `Om din ansökan godkänns kommer du att få e-postmeddelanden från BizGive när du måste uppdatera dina indikatorer.`,
  how_often_do_I_update_my_indicators: `Hur ofta uppdaterar jag mina indikatorer?`,
  you_will_be_asked_to_update_your_indicators_at_the_same_time: `Du kommer att bli ombedd att uppdatera dina indikatorer samtidigt som du blir ombedd att skicka in din delårsuppdatering eller slutrapport.`,
  measuring_progress: `Mäta framsteg`,
  objective_outcome_specific_indicators: `Mål/resultatspecifika indikatorer`,
  mandatory_title: `Obligatorisk`,
  about_your_project: `Om ditt projekt`,
  your_request: `Din förfrågan`,
  planned_impact_title: `Planerad påverkan`,
  award_criteria: `Priskriterier`,
  step_1: `Steg 1`,
  step_2: `Steg 2`,
  step_3: `Steg 3`,
  step_4: `Steg 4`,
  step_5: `Steg 5`,
  submit_your_application: `Skicka in din ansökan`,
  to_submit_your_application_you_must_read_and_agree_to_the_application: `För att skicka in din ansökan måste du läsa och godkänna ansökan`,
  terms_and_conditions: `Regler och villkor`,
  below: `nedan.`,
  please_note_you_will_not_be_able_to_edit_your_application_after_it_has_been_submitted_unless_requested_to_by_the_company_youre_applying_to: `Observera att du inte kommer att kunna redigera din ansökan efter att den har skickats in, såvida det inte begärs av företaget du ansöker till.`,
  by_submitting_this_application_you_will_be_sharing_your_application_user_details_and_ongoing_entity_profile_information_with_the_funder: `Genom att skicka in denna ansökan kommer du att dela din ansökan, användarinformation och löpande enhetsprofilinformation med finansiären.`,
  enter_caption: `Ange bildtext...`,
  impact_alignment: `Effektanpassning`,
  approve: `Godkänna`,
  decline: `Nedgång`,
  requested_support: `Begärt support`,
  total_request: `Total begäran`,
  total_project_budget: `Total projektbudget`,
  funder_contribution: `Finansieringsbidrag`,
  planned_expenditure: `Planerade utgifter`,
  additional_funding: `Ytterligare finansiering`,
  additional_funding_is_required_to_meet_the_total_opportunity_budget: `Ytterligare finansiering krävs för att klara den totala möjlighetsbudgeten`,
  where_will_additional_funds_be_sourced: `Var kommer ytterligare medel att hämtas?`,
  has_this_funding_been_secured: `Har denna finansiering säkrats?`,
  can_this_project_go_ahead_without_additional_funding: `Kan detta projekt fortsätta utan ytterligare finansiering?`,
  outputs: `Utgångar`,
  you_must_select_yes_to_proceed: `Du måste välja Ja för att fortsätta`,
  please_enter_the_dates_within_the_above_mentioned_limits: `Vänligen ange datumen inom ovan nämnda gränser`,
  at_least_one_checkbox_must_be_selected: `Minst en kryssruta måste vara markerad`,
  delete_confirmation: `Ta bort bekräftelse`,
  unchecking_this_box_will_delete_any_underlying_data_you_have_entered_for_this_objective_or_outcome: `Om du avmarkerar den här rutan raderas alla underliggande data som du har angett för detta mål eller resultat.`,
  at_least_one_outcome_must_be_selected: `Minst 1 resultat måste väljas`,
  please_select_at_least_one_objective: `Välj minst ett mål`,
  project_timelines: `Projektets tidslinjer`,
  project_location: `Projektets plats`,
  pending_title: `I avvaktan på`,
  view_indicator: `Visa indikator`,
  indicators_status_confirmation: `Indikatorstatus Bekräftelse`,
  indicators_successfully_submitted: `Indikatorer har skickats in`,
  please_create_at_least_indicator_outcome: `Skapa minst en indikator per resultat`,
  please_complete_n_delete_pending_indicators: `Fyll i eller ta bort väntande indikatorer`,
  modal_will_be_closed_after_two_seconds: `Modalen kommer att stängas efter två sekunder`,
  please_enter_indicatorInterimActual: `Vänligen ange indikatorInterimActual`,
  no_comments: `Inga kommentarer`,
  enter_final_total: `Ange slutsumman`,
  milestone_date: `Milstolpedatum`,
  accumulative_target: `Ackumulativt mål`,
  actuals: `Faktiskt`,
  evidence: `Bevis`,
  total_target: `Totalt mål`,
  please_enter_total_accumulative_target: `Ange totalt ackumulerat mål`,
  please_add_value_for_historic_milestone: `Lägg till ett värde för varje historisk milstolpe`,
  cancel_uppercase: `AVBOKA`,
  submit_uppercase: `ÖVERLÄMNA`,
  press_submit_to_confirm: `Tryck på Skicka för att bekräfta din inmatning. Observera att detta kommer att delas med`,
  confirmation: `Bekräftelse`,
  your_donor_n_can_not_be_edited: `din givare och kan inte redigeras`,
  indicator_name: `Indikatornamn`,
  please_enter_indicator_name: `Vänligen ange indikatornamn`,
  main_focus: `Huvudfokus`,
  social_n_beneficiaries: `Sociala / förmånstagare`,
  please_select_beneficiaries: `Välj förmånstagare`,
  please_enter_unit: `Vänligen ange enhet`,
  how_will_you_measure_progress: `Hur kommer du att mäta framsteg?`,
  starting_number_level_indicator: `Startnummer/nivå för din indikator`,
  if_you_do_not_know_this_then_enter_zero: `Om du inte vet detta anger du 0`,
  target_number_or_level_reach: `Målnummer eller nivå att nå`,
  target_we_aim_to_reach_is: `Målet vi vill nå är`,
  from_starting_number_n_level: `från startnumret/nivån`,
  estimate_what_change_starting_para: `Valfritt: Uppskatta vad förändringen i startnumret/nivån skulle vara i slutet av din Opportunity-tidslinje om du inte ingrep?`,
  your_total_effort_will_be: `Din totala ansträngning kommer att vara`,
  taking_account_you_did_not_intervene: `med hänsyn till vad som skulle hända om du inte ingrep`,
  how_will_you_gather_evidence: `Hur ska du samla bevis?`,
  please_enter_details: `Vänligen ange detaljer`,
  evidence_verification_method: `Metod för bevisverifiering`,
  your_contribution: `Ditt bidrag`,
  measuring_your_impact: `Mäta din inverkan`,
  to_measure_the_progress_of_your_opportunity: `För att mäta utvecklingen av din möjlighet har företaget bett dig att lägga till indikatorer. Med indikatorer kan du sätta upp uppskattade mål, med milstolpar för att uppnå dem.`,
  opportunity_indicators: `Möjlighetsindikatorer`,
  these_indicators_are_general_to_your_opportunity_or_entity: `Dessa indikatorer är generella för din möjlighet eller enhet. Klicka på "Lägg till" för att skapa dem.`,
  these_indicators_support_the_specific_objectives_and_outcomes: `Dessa indikatorer stödjer de specifika målen och resultaten av din möjlighet. Klicka på "Lägg till" för att skapa dem`,
  describe_the_starting_situation: `Beskriv startsituationen:`,
  describe_the_final_situation: `Beskriv önskad målslutsituation:`,
  describe_the_final_title_situation: `Beskriv önskad slutsituation:`,
  please_confirm_that_you_can_provide_any_of_following_evidence_items: `Bekräfta att du kan tillhandahålla följande bevis`,
  starting_number_level_of_your_indicator: `Startnummer för din indikator`,
  target_number_or_level_to_reach: `Målnummer att nå`,
  estimate_what_the_change_in_the_starting_number: `Valfritt: Uppskatta vad förändringen i startnumret/nivån skulle vara i slutet av din Opportunity-tidslinje om du inte ingrep?`,
  the_target_we_aim_to_reach_is_employed_from_the_starting_number_level: `Målet vi strävar efter är anställda Antal anställda från startnummer/nivå`,
  your_total_impact_will_be_employed: `Din totala påverkan kommer att vara impactNumber anställd`,
  your_final_absolute_change_is_impactNumber: `Din sista absoluta förändring är impactNumber`,
  your_final_relative_change_is_impactNumber: `Din sista relativa förändring är impactNumber`,
  we_will_aim_for_sample_size_of_individuals: `Vi kommer att sikta på en urvalsstorlek på 20 personer...`,
  restrict_applications_to_within_certain_radius_of_this_location: `Begränsa applikationer till inom en viss radie från den här platsen?`,
  enter_number: `Ange nummer`,
  biannually: `Vartannat år`,
  please_select_your_impact_strategy: `Välj din effektstrategi`,
  reporting_requirements: `Rapporteringskrav`,
  starting: `Startande`,
  create_indicator: `Skapa indikator`,
  optional_title: `Frivillig`,
  estimate_what_the_level_would_be: `Uppskatta vad ändringen i startnumret skulle vara till ditt projektslutdatum om du inte ingrep? (lägg till +/- tecken)`,
  this_value_cannot_be_more_than_the_amount_you_are_applying_for: `Detta värde kan inte vara högre än det belopp du ansöker om`,
  you_must_apply_for_100_percentage_of_the_total_project_cost: `Du måste ansöka om 100 % av den totala projektkostnaden`,
  please_save_a_location: `Spara en plats`,
  i_agree: `Jag håller med`,
  project_running_dates: `Projekt löpande datum`,
  donations_required_before: `Donationer krävs innan`,
  add_programme: `Lägg till program`,
  budget_end_date: `Slutdatum för budget`,
  application_window: `Applikationsfönster`,
  choose_either_option: `Välj något av alternativen:`,
  copy_an_existing_programme: `Kopiera ett befintligt program`,
  create_a_new_programme: `Skapa ett nytt program`,
  what_is_the_name_of_your_programme: `Vad heter ditt program?`,
  what_is_the_area_of_impact: `Vilket är påverkansområdet?`,
  projects_or_impact_must_be_within: `Projekt eller påverkan måste ligga inom:`,
  a_custom_area: `Ett anpassat område`,
  an_administrative_boundary_eg_a_council_area_or_country: `En administrativ gräns t.ex. ett rådsområde eller land.`,
  a_certain_distance_from_a_point: `Ett visst avstånd från en punkt.`,
  click_on_the_map_to_start_drawing_your_area: `Klicka på kartan för att börja rita ditt område, dubbelklicka för att slutföra det. Om det behövs kan du ta bort det från alternativet för områdesnamn under kartan genom att klicka på raderingsikonen till höger om`,
  use_the_search_box_to_find_administrative_boundaries: `Använd sökrutan för att hitta administrativa gränser. Visa en gräns genom att klicka på namnet, välj en gräns genom att klicka på "Välj". Ta bort områden eller redigera namn från avsnittet områdesnamn under `,
  click_on_the_map_to_add_a_point: `Klicka på kartan för att lägga till en punkt, ange sedan en tillåten radie nedan och tryck på "Generera område" för att visa området på kartan. Börja igen genom att klicka på kartan för att lägga till en ny punkt.`,
  what_is_the_area_called: `Vad heter området?`,
  programme_details: `Programinformation`,
  write_a_short_summary_of_your_programme: `Skriv en kort sammanfattning av ditt program`,
  write_a_longer_description: `Skriv en längre beskrivning`,
  do_you_wish_to_share_any_supporting_material: `Vill du dela med dig av något stödmaterial?`,
  select_all_options: `Välj alla alternativ`,
  indicators: `Indikatorer`,
  details: `Detaljer`,
  programme_support: `Programstöd`,
  what_support_can_you_offer: `Vilket stöd kan du erbjuda?`,
  what_is_your_budget: `Vad är din budget`,
  make_this_budget_amount_visible_in_your_programme_as_an_estimated_budget: `Gör detta budgetbelopp synligt i ditt program som en "uppskattad budget"`,
  is_there_a_limit_donation_amount_per_project: `Finns det en gräns för donationsbelopp per projekt?`,
  projects_must_be_fully_funded_by_you_without_additional_third_party_funding: `Projekt måste finansieras helt av dig utan ytterligare finansiering från tredje part`,
  does_this_budget_recur: `Återkommer denna budget?`,
  per_project: `Per projekt`,
  no_it_is_fixed: `Nej, det är fixat.`,
  yes_annual_starting_on: `Ja, årligen börjar på:`,
  please_include_in_your_invoice_the_following_details: `Vänligen inkludera följande uppgifter på din faktura...`,
  share_any_invoice_instructions_for_approved_grantees_to_view: `Dela eventuella fakturainstruktioner för godkända bidragstagare att se`,
  do_you_want_to_upload_an_invoice_template_for_approved_applicants_to_use: `Vill du ladda upp en fakturamall som godkända sökande kan använda?`,
  what_type_of_volunteering_can_you_offer: `Vilken typ av volontärarbete kan du erbjuda?`,
  what_skilled_volunteering_is_available: `Vilket skickligt volontärarbete finns?`,
  start_date: `Startdatum`,
  end_date: `Slutdatum`,
  general: `Allmän`,
  skilled: `Skicklig`,
  skill: `Skicklighet`,
  number_of_item_service: `Antal (vara/tjänst)`,
  item_service_description: `Artikel/tjänstbeskrivning`,
  what_type_of_in_kind_support_can_you_offer: `Vilken typ av naturastöd kan du erbjuda?`,
  timelines: `Tidslinjer`,
  when_are_you_accepting_applications: `När tar du emot ansökningar?`,
  a_date_range: `Ett datumintervall`,
  ongoing: `Pågående`,
  when_are_application_decisions_made: `När fattas ansökningsbeslut?`,
  periodically: `Periodvis`,
  when_do_you_expect_to_make_donations: `När förväntar du dig att göra donationer?`,
  do_you_want_to_restrict_project_timelines: `Vill du begränsa projektets tidslinjer?`,
  projects_must_start_within: `Projekt måste starta inom`,
  projects_must_not_be_longer_than: `Projekt får inte vara längre än`,
  months: `månader`,
  eligible_entities: `Kvalificerade enheter`,
  what_type_of_entity_is_able_to_apply_to_your_programme: `Vilken typ av enhet kan ansöka till ditt program?`,
  please_select_all_that_apply_below: `Välj alla som stämmer nedan.`,
  uk: `Storbritannien`,
  international: `Internationell`,
  applicants_must_agree_to_these_before_applying: `Sökande måste godkänna dessa innan de ansöker`,
  entity_project_must_be: `Entitet/projekt måste vara...`,
  application_questions: `Ansökningsfrågor`,
  do_you_want_to_add_any_custom_application_questions: `Vill du lägga till några anpassade applikationsfrågor?`,
  word_limit: `Ordgräns`,
  question: `Fråga`,
  please_enter_your_application_terms_and_conditions: `Ange dina ansökningsvillkor`,
  we_ask_all_applicants_to_approve_this_before_submitting_their_application: `Vi ber alla sökande att godkänna detta innan de skickar in sin ansökan.`,
  please_enter_a_link_to_your_privacy_policy: `Ange en länk till din integritetspolicy`,
  we_ask_all_applicants_to_acknowledge_this_before_submitting_their_application: `Vi ber alla sökande att bekräfta detta innan de skickar in sin ansökan.`,
  measuring_impact: `Mätning av påverkan`,
  when_do_you_want_to_receive_interim_updates: `När vill du få "Interimsuppdateringar"?`,
  recurring_to_project_dates: `Återkommande till projektdatum`,
  not_required: `Krävs inte`,
  every: `Varje`,
  days_between_project_start_and_end_dates: `Dagar mellan projektstart och slutdatum`,
  when_do_you_want_to_receive_a_final_report: `När vill du få en "slutrapport"?`,
  relative_to_project_dates: `I förhållande till projektdatum`,
  days_after_the_project_end_date: `Dagar efter projektets slutdatum`,
  are_there_any_additional_questions_you_would_like_to_ask_in_the_final_report: `Finns det några ytterligare frågor du skulle vilja ställa i slutrapporten?`,
  do_you_want_additional_legal_terms_for_entities_to_accept_on_submission_of_reports_to_you: `Vill du ha ytterligare juridiska villkor för enheter att acceptera vid inlämnande av rapporter till dig?`,
  programme_administration: `Programadministration`,
  internal_approval_steps: `Steg för internt godkännande`,
  approval_step: `Steg för godkännande`,
  voting: `Röstning`,
  scoring_category: `Poängkategori`,
  create_the_categories_that_you_would_like_to_evaluate_applications_against: `Skapa de kategorier som du skulle vilja utvärdera ansökningar mot t.ex. "Valuta för pengarna" eller "Total effekt"`,
  insert: `Infoga`,
  scoring_category_options: `Poängkategorialternativ`,
  detail_the_category_options_available_to_be_selected_for_the_above_categories: `Detaljera de kategorialternativ som är tillgängliga för kategorierna ovan med "numeriskt värde" för varje alternativ, så att ett slutresultat kan beräknas. Du kan också valfritt inkludera en beskrivning`,
  list_the_scoring_category_options_with_a_value_and_an_optional_description: `Lista alternativen för poängkategorin med ett värde och en valfri beskrivning. Till exempel kan värdet vara "1" och beskrivningen "Låg" eller värdet "3" och beskrivningen "Hög".`,
  numerical_value: `Numeriskt värde`,
  optional_description: `Valfri beskrivning`,
  who_will_manage_this_programme: `Vem kommer att hantera detta program?`,
  managers_can_edit_the_programme_interact_with_applicants_approve_applications_and_receive_related_email_notifications: `Chefer kan redigera programmet, interagera med sökande, godkänna ansökningar och få relaterade e-postmeddelanden.`,
  who_can_view_this_programme: `Vem kan se detta program`,
  viewers_can_view_the_programme_and_applications_but_not_edit_the_programme: `Tittarna kan se programmet och ansökningarna men inte redigera programmet, interagera med sökande, godkänna ansökningar eller få relaterade e-postmeddelanden.`,
  programme_visibility: `Programsynlighet`,
  bizGive_open: `BizGive (öppen)`,
  any_charity_signed_up_to_bizGive_can_view_and_apply_to_your_programme: `Alla välgörenhetsorganisationer som registrerat sig för BizGive kan se och ansöka om ditt program.`,
  bizGive_invite_only: `BizGive (endast inbjudan)`,
  only_charities_you_invite_to_apply_to_your_programme_can_view_it: `Endast välgörenhetsorganisationer som du bjuder in till ditt program kan se det.`,
  public_open: `Offentlig (öppen)`,
  your_programme_will_have_its_own_link_and_branded_landing_page_on_bizGive: `Ditt program kommer att ha en egen länk och en varumärkesbaserad målsida på BizGive, så att du kan dela den var som helst utanför plattformen. Alla välgörenhetsorganisationer som registrerat sig för BizGive kommer också att kunna se och ansöka.`,
  public_invite_only: `Offentlig (endast inbjudan)`,
  your_programme_will_have_its_own_link_and_branded_landing_page_on_bizGive_invite_them_to_apply: `Ditt program kommer att ha en egen länk och en varumärkesbaserad målsida på BizGive, så att du kan dela den var som helst utanför plattformen. Det kommer inte att vara synligt för välgörenhetsorganisationer som registrerat sig för BizGive, om du inte är med`,
  add_a_custom_programme_url: `Lägg till en anpassad program-URL`,
  publish_your_programme: `Publicera ditt program`,
  this_will_make_your_programme_visible_as_per_your_visibility_settings: `Detta kommer att göra ditt program synligt enligt dina synlighetsinställningar.`,
  you_can_still_edit_all_details_of_the_programmes_after_publishing: `Du kan fortfarande redigera alla detaljer om programmen efter publicering.`,
  required_document_name: `Obligatoriskt dokumentnamn`,
  change: `Ändra`,
  number_of_days: `Antal dagar`,
  programme_approval: `Programgodkännande`,
  there_must_be_at_least_1_votingScoreCriteria_added: `Det måste läggas till minst 1 votingScoreCriteria`,
  there_must_be_at_least_1_votingCriteriaOptions_added: `Det måste läggas till minst 1 röstkriterier`,
  publish: `Publicera`,
  confirm: `Bekräfta`,
  project_timeline: `Projektets tidslinje`,
  company: `Företag`,
  this_programme_is_closing_in_number_days: `Detta program stänger om antal dagar`,
  this_programme_is_now_closed: `Detta program är nu stängt`,
  the_application_window_is: `Programfönstret är`,
  login_or_signup_into_bizGive_to_discover_new_funding_programmes: `Logga in eller registrera dig på BizGive för att upptäcka nya finansieringsprogram.`,
  discover_more_programmes: `Upptäck fler program`,
  end: `Avsluta`,
  to_apply_to_the: `Att ansöka om`,
  log_in_or_sign_up_to_create_your_free_bizGive_account: `Logga in eller registrera dig för att skapa ditt gratis BizGive-konto.`,
  if_youre_new_to_BizGive_create_an_organisation_profile: `Om du är ny på BizGive, skapa en organisationsprofil.`,
  complete_your_application_to_the_programme: `Fyll i din ansökan till programmet.`,
  receive_alerts_when_action_is_required_or_a_funding_decision_is_made: `Få varningar när åtgärder krävs eller ett finansieringsbeslut fattas.`,
  apply_to_other_programmes_from_the_discover_section: `Ansök till andra program från Discover-sektionen.`,
  entity_location: `Entitetsplats`,
  which_country_must_entities_be_located_in_leave_blank_if_any_are_accepted: `I vilket land måste enheterna finnas? Lämna tomt om några godkänns`,
  search_country: `Sök land`,
  already_registered: `Redan registrerad?`,
  login_here: `Logga in här`,
  application_to: `Ansökan till`,
  continue_application: `Fortsätt ansökan`,
  delete_application: `Ta bort applikation`,
  edit_resubmit: `Redigera och skicka på nytt`,
  withdraw: `Dra tillbaka`,
  this_will_withdraw_your_application_and_return_it_to_a_pending_state: `Detta kommer att dra tillbaka din ansökan och återställa den till ett "Väntande"-läge.`,
  this_will_delete_your_application_and_saved_data: `Detta kommer att radera din applikation och sparade data.`,
  withdraw_application: `Dra tillbaka ansökan`,
  send: `Skicka`,
  enable_editing_of_application: `Aktivera redigering av applikation`,
  application_editing_enabled: `Programredigering aktiverad`,
  pre_approve: `Förhandsgodkänna`,
  withdraw_pre_approval: `Återkalla förhandsgodkännande`,
  confirm_approval: `Bekräfta godkännande`,
  grant_award: `Grant Award`,
  please_confirm_you_wish_to_approve_this_application: `Vänligen bekräfta att du vill godkänna denna ansökan.`,
  share_a_message: `Dela ett meddelande:`,
  confirm_decline: `Bekräfta avvisa`,
  please_explain_your_decision_to_the_applicant: `Vänligen förklara ditt beslut för den sökande`,
  application_related: `Applikationsrelaterad`,
  entity_related: `Entitetsrelaterad`,
  programme_related: `Programrelaterat`,
  add_a_message: `Lägg till ett meddelande`,
  there_are_items_we_cannot_fund: `Det finns saker som vi inte kan finansiera`,
  the_impact_of_your_project_is_not_clear_enough: `Effekten av ditt projekt är inte tillräckligt tydlig`,
  the_impact_of_your_project_is_lower_relative_to_other_applications: `Effekten av ditt projekt är lägre jämfört med andra applikationer.`,
  your_entity_does_not_meet_our_criteria: `Din enhet uppfyller inte våra kriterier`,
  your_project_does_not_align_closely_enough_with_our_objectives: `Ditt projekt överensstämmer inte tillräckligt med våra mål`,
  other_projects_more_closely_aligned_with_our_objectives: `Andra projekt ligger mer i linje med våra mål`,
  your_project_did_not_fully_meet_our_eligibility_criteria: `Ditt projekt uppfyllde inte helt våra behörighetskriterier`,
  funding_in_this_round_has_already_been_disbursed_to_similar_projects: `Finansiering i denna omgång har redan betalats ut till liknande projekt`,
  please_select_an_decline_option_or_write_a_message: `Välj ett avslagsalternativ eller skriv ett meddelande`,
  confirm_pre_approval: `Bekräfta förhandsgodkännande`,
  please_confirm_your_pre_approval: `Vänligen bekräfta ditt förhandsgodkännande.`,
  please_confirm_your_approval: `Vänligen bekräfta ditt godkännande.`,
  pre_approving_will_not_notify_the_applicant: `Förhandsgodkännande kommer inte att meddela den sökande.`,
  approving_will_not_notify_the_applicant: `Att godkänna kommer inte att meddela den sökande.`,
  internal_review: `Intern granskning`,
  entity_history: `Entitetshistoria`,
  you_have_received_an_application_from_this_entity_before: `Du har fått en ansökan från denna enhet tidigare.`,
  approval: `Godkännande`,
  approved_by: `Godkänd av`,
  confirm_step_completion: `Bekräfta slutförandet av steg`,
  please_confirm_this_step_has_been_completed: `Vänligen bekräfta att detta steg har slutförts.`,
  total_score: `Totalt resultat`,
  voters: `Väljare`,
  category_totals: `Kategori Summor`,
  name: `Namn`,
  telephone: `Telefon`,
  email: `E-post`,
  category_score: `Kategori Poäng`,
  date: `Datum`,
  my_vote: `Min röst`,
  saved: `Sparad`,
  vote: `Rösta`,
  value_for_money: `Valuta för pengarna`,
  total_impact: `Total påverkan`,
  total: `Total`,
  comments: `Kommentarer`,
  edit: `Redigera`,
  what_are_your_overall_comments: `Vilka är dina övergripande kommentarer?`,
  select_score: `Välj Betyg`,
  please_select_at_least_one_checkbox: `Markera minst en kryssruta`,
  create_your_profile: `Skapa din profil`,
  on_the_following_screens_you_will_be_asked_to_complete_a_profile_of_your_entity: `På följande skärmar kommer du att bli ombedd att fylla i en profil för din enhet.`,
  how_your_profile_is_used: `Hur din profil används`,
  once_your_profile_is_complete_it_will_be_automatically_attached_to_any_application_you_submit_through_bizGive: `När din profil är klar kommer den automatiskt att bifogas till alla ansökningar du skickar in via BizGive.`,
  companies_and_bizGive_use_your_profile_to_perform_background_due_diligence_checks_on_your_organisation_it_is_only_visible_to_companies_you_apply_to: `Företag och BizGive använder din profil för att utföra bakgrundskontroller av din organisation. Det är endast synligt för företag du ansöker till.`,
  once_complete_you_will_be_able_to_apply_to_as_many_company_programmes_as_you_re_eligible_for_from_the_discover_tab: `När du är klar kommer du att kunna ansöka till så många företagsprogram som du är berättigad till från fliken "Upptäck".`,
  profile_guidance: `Profilvägledning`,
  saves_your_data_and_moves_you_to_the_next_screen_your_answers_will_automatically_be_saved_unless_you_have_an_internet_connectivity_issue: `sparar dina data och flyttar dig till nästa skärm. Dina svar sparas automatiskt om du inte har problem med internetanslutningen.`,
  saves_your_data_and_logs_you_out_of_bizGive: `sparar dina data och loggar ut dig från BizGive. Du kommer att kunna fortsätta din profil när du loggar in igen. Du måste fylla i alla obligatoriska fält för att "Spara och avsluta" (du kan ange slumpmässiga val`,
  entity_details: `Enhetsdetaljer`,
  name_n_address: `Namn & adress`,
  do_you_have_a_different_trading_name_or_display_name: `Har du ett annat handelsnamn eller visningsnamn?`,
  legal_structure: `Rättslig struktur`,
  what_is_your_legal_structure: `Vad är din juridiska struktur?`,
  unregistered_organisation: `Oregistrerad organisation`,
  what_is_your_registration_number: `Vad är ditt registreringsnummer?`,
  this_is_your_registration_number_with_the_relevant_regulator_of_your_entity: `Detta är ditt registreringsnummer hos den relevanta tillsynsmyndigheten för din enhet.`,
  please_share_a_link_to_your_online_registration: `Vänligen dela en länk till din onlineregistrering`,
  this_is_a_link_to_your_profile_on_the_regulators_website: `Detta är en länk till din profil på tillsynsmyndighetens webbplats.`,
  please_upload_a_copy_of_your_governing_document: `Ladda upp en kopia av dina styrande dokument`,
  these_are_not_available: `Dessa är inte tillgängliga`,
  please_share_a_reason: `Dela gärna en anledning`,
  please_upload_a_copy_of_your_governing_documents: `Ladda upp en kopia av dina styrande dokument`,
  for_example_your_trust_deed: `Till exempel din förtroendehandling.`,
  please_upload_a_copy_of_your_most_recent_annual_accounts: `Ladda upp en kopia av ditt senaste årsbokslut`,
  for_example_your_Articles_of_association: `Till exempel din bolagsordning.`,
  please_upload_a_copy_of_your_constitution_trust_deed_or_rules: `Ladda upp en kopia av din författning, förtroendehandling eller regler`,
  please_upload_a_copy_of_your_registration_documents_or_most_recent_annual_accounts: `Ladda upp en kopia av dina registreringshandlingar eller senaste årsbokslut`,
  entity_types: `Enhetstyper`,
  registered_with_the_relevant_national_or_regional_regulatory_authority_for_example_the_charity_commission_in_the_uk: `Registrerad hos relevant nationell eller regional tillsynsmyndighet. Till exempel Charity Commission i Storbritannien.`,
  community_interest_company_uk_only: `Community Interest Company (endast Storbritannien)`,
  registered_with_companies_house: `Registrerad hos Companies House. En särskild form av icke-välgörande aktiebolag som är till för att gynna en gemenskap eller fullgöra ett socialt syfte. Många sociala företag är CIC.`,
  a_type_of_charity_run_by_a_small_group_of_people_known_as_trustees: `En typ av välgörenhet som drivs av en liten grupp människor som kallas förvaltare. I Storbritannien måste en stiftelse registrera sig hos Charity Commission när dess årsinkomst överstiger 5 000 pund.`,
  an_educational_institution_such_as_a_university_or_school: `En utbildningsinstitution som ett universitet eller en skola.`,
  an_entity_that_is_not_registered_or_regulated_for_example_clubs_societies_and_small_community_groups: `En enhet som inte är registrerad eller reglerad. Till exempel klubbar, sällskap och små samhällsgrupper.`,
  a_type_of_charitable_organisation_registered_as_a_company_limited_by_guarantee: `En typ av välgörenhetsorganisation registrerad som Company Limited by Guarantee eller annan ideell företagsstruktur. I Storbritannien är de registrerade hos Companies House as a Company Limited av Gu`,
  organisations_that_are_responsible_for_the_provision_of_public_services: `Organisationer som ansvarar för tillhandahållandet av offentliga tjänster.`,
  trustees: `Förvaltare`,
  please_provide_the_name_of_your_trustees_or_directors: `Ange namnet på dina förvaltare eller styrelseledamöter.`,
  a_minimum_of_two_is_required_only_1_is_required_if_you_are_a_uk_cic: `Minst 2 krävs. Endast 1 krävs om du är en brittisk CIC.`,
  where_are_you_able_to_run_your_projects: `Var kan du driva dina projekt?`,
  based_on_your_selections_we_will_be_able_to_recommend_relevant_new_funding_programmes_to_you: `Baserat på dina val kommer vi att kunna rekommendera relevanta nya finansieringsprogram till dig.`,
  countries_of_operation: `Verksamhetsländer`,
  within_your_selected_countries_can_you_run_projects_nationwide_or_in_specific_locations_only: `Kan du driva projekt rikstäckande eller endast på specifika platser inom dina utvalda länder?`,
  nationwide: `Rikstäckande`,
  specific_locations: `Specifika platser`,
  please_describe_what_your_organisation_does: `Beskriv vad din organisation gör`,
  please_provide_a_brief_overview_of_your_groups_purpose_aims_and_objectives: `Ge en kort översikt över din grupps syfte, mål och mål.`,
  social_media: `Sociala medier`,
  please_share_a_link_to_your_website: `Dela gärna en länk till din webbplats`,
  if_applicable_please_share_your_social_media_links: `Om tillämpligt, vänligen dela dina länkar till sociala medier`,
  please_add_your_entity_logo: `Vänligen lägg till din enhetslogotyp`,
  your_profile_is_complete: `Din profil är komplett`,
  you_can: `Du kan`,
  edit_title_caption: `'Redigera'`,
  your_profile_at_any_point_by_clicking_into: `din profil när som helst genom att klicka på "Min organisation" > "Profil" > "Redigera"`,
  what_happens_next: `Vad händer härnäst?`,
  start_your_application: `Starta din ansökan`,
  if_you_accessed_bizGive_via_a_company_programme: `Om du fick tillgång till BizGive via ett företagsprogram, klicka på "Ansök" för att starta ditt ansökningsformulär.`,
  discover_company_programmes: `Upptäck företagsprogram`,
  click_discover_to_view_and_apply_to_live_company_support_programmes: `Klicka på "Upptäck" för att se och ansöka om direkta företagssupportprogram.`,
  enter_url: `Ange URL`,
  please_upload_documentation: `Ladda upp dokumentation`,
  council_or_government_linked_entity: `Råd eller regeringsanknuten enhet`,
  locations: `Platser`,
  specific_locations_within_each_country: `Specifika platser inom varje land`,
  entity_type: `Entitetstyp`,
  legal_name: `Juridiskt namn`,
  governing_documents: `Styrande dokument`,
  operating_location: `Driftplats`,
  nationally_in_the_following_countries: `Nationellt i följande länder:`,
  locally_in_the_following_countries: `Lokalt i följande länder:`,
  not_available: `Inte tillgänglig`,
  registration_number: `Registreringsnummer`,
  trading_name: `Handelsnamn`,
  web_uri: `Webb-URI`,
  registration_profile_url: `Registreringsprofilens URL`,
  discover_funding_opportunities: `Upptäck finansieringsmöjligheter`,
  available_programmes_filtered_by_your_entitys_area_of_operation: `Tillgängliga program filtrerade efter din enhets verksamhetsområde:`,
  change_here: `Ändra här`,
  programme: `Programmera`,
  applications_accepted: `Ansökningar godkända`,
  decision_made: `Beslut fattat`,
  location: `Plats`,
  action: `Handling`,
  your_entity_type_is_not_supported_by_this_programme: `Din enhetstyp stöds inte av detta program.`,
  please_click_ok_and_view_the_permitted_entities_in_the_programme_review_page: `Klicka på "OK" och se de tillåtna enheterna på sidan för programgranskning.`,
  content: `Innehåll`,
  select_programme: `Välj Program`,
  select_report_type: `Välj rapporttyp`,
  enter_start_date: `Ange startdatum`,
  enter_end_date: `Ange slutdatum`,
  report: `Rapportera`,
  overdue: `Försenad`,
  view_report: `Visa rapport`,
  start_report: `Starta rapport`,
  complete_report: `Komplett rapport`,
  add_your_profile_picture: `Lägg till din profilbild`,
  project: `Projekt`,
  registration_website: `Registreringswebbplats`,
  outside_of_impact_area: `Utanför nedslagsområdet`,
  this_interim_update_is_for: `Denna interimsuppdatering är för`,
  interim_update_deadline: `Interims uppdateringsdeadline`,
  form_guidance: `Formvägledning`,
  in_the_form_you_will_be_asked_to_share_details_of_the_project_you_received_funding_for: `I formuläret kommer du att bli ombedd att dela information om projektet du fått finansiering för.`,
  to_access_a_saved_interim_update_click_into_impact: `För att komma åt en sparad interimsuppdatering: Klicka på Impact > Content >`,
  to_access_a_saved_interim_update_click_into_impact_content: `För att se en inskickad interimsuppdatering: Klicka på Effekt > Innehåll > Visa rapport`,
  interim_update: `Interimsuppdatering`,
  below_is_the_support_you_requested_from_the_company_in_your_application: `Nedan finns det stöd du begärt från företaget i din ansökan.`,
  how_have_you_used_the_support_provided_so_far: `Hur har du använt det stöd som getts hittills?`,
  are_there_any_changes_to_your_planned_expenditure_and_if_so_why: `Finns det några förändringar av dina planerade utgifter och i så fall varför?`,
  are_there_any_changes_to_your_estimated_completion_date_and_if_so_why: `Finns det några ändringar av ditt beräknade slutdatum och i så fall varför?`,
  please_email_bizGive: `Vänligen maila BizGive`,
  if_there_is_a_substantial_change_to_your_completion_date_and_we_will_ensure_the_deadline_for_your_final_report_is_update: `om det finns en väsentlig förändring av ditt slutdatum och vi kommer att se till att deadline för din slutrapport uppdateras.`,
  share_images: `Dela media`,
  please_upload_images_to_bring_your_project_to_life_this_significantly_increases_the_likelihood_of_the_company_sharing_your_content: `Ladda upp media för att ge ditt projekt liv. Detta ökar avsevärt sannolikheten för att företaget delar ditt innehåll.`,
  sends_your_form_to_the_company: `skickar ditt formulär till företaget. Den här knappen visas på formulärets sista skärm.`,
  submit_your_report: `Skicka in din rapport`,
  i_have_read_and_agree_to_the_above_terms: `Jag har läst och godkänner ovanstående villkor.`,
  please_confirm_that_all_necessary_copyrights_and_acknowledgements_have_been_added: `Vänligen bekräfta att alla nödvändiga upphovsrätter och bekräftelser har lagts till.`,
  i_confirm_that_all_necessary_copyrights_and_acknowledgements_have_been_added: `Jag bekräftar att alla nödvändiga upphovsrätter och bekräftelser har lagts till.`,
  final_report_deadline: `Deadline för slutrapport`,
  please_press_add_to_save_the_invited_user: `Vänligen tryck på lägg till för att spara den inbjudna användaren`,
  inputs: `Ingångar`,
  did_any_of_your_plans_change: `Har någon av dina planer ändrats?`,
  please_select_and_enter_your_final_inputs: `Vänligen välj och ange dina slutgiltiga inmatningar`,
  please_update_your_expenditure: `Uppdatera dina utgifter`,
  please_update_the_items_or_services_you_used: `Uppdatera de varor eller tjänster du använde`,
  please_update_the_volunteering_support_you_used: `Vänligen uppdatera det volontärstöd du använde`,
  below_are_the_outputs_you_shared_in_your_application: `Nedan är de utgångar du delade i din ansökan.`,
  did_your_outputs_change: `Har dina utgångar förändrats?`,
  please_update_your_outputs: `Uppdatera dina utdata`,
  your_outputs_will_show_like_this_in_your_report: `Dina utdata kommer att visas så här i din rapport:`,
  i_acknowledge_the: `Jag erkänner`,
  below_are_the_beneficiaries_you_shared_in_your_application: `Nedan är förmånstagarna du delade i din ansökan.`,
  did_your_social_beneficiary_types_change: `Förändrades dina typer av socialbidragstagare?`,
  please_update_your_social_beneficiary_types: `Uppdatera dina typer av sociala förmånstagare`,
  did_your_social_beneficiary_numbers_change: `Har dina sociala förmånstagares siffror förändrats?`,
  please_update_your_social_beneficiary_numbers: `Uppdatera dina sociala förmånstagares nummer`,
  did_your_environmental_beneficiaries_change: `Förändrades dina miljöförmåner?`,
  please_update_your_environmental_beneficiaries: `Uppdatera dina miljöförmånstagare`,
  below_are_the_objectives_and_outcomes_you_shared_in_your_application: `Nedan är de mål och resultat du delade med dig av i din ansökan.`,
  objectives_n_outcomes: `Mål & resultat`,
  were_you_successful_in_achieving_your_objectives_and_outcomes: `Var du framgångsrik i att uppnå dina mål och resultat?`,
  inputs_n_outputs: `Ingångar och utgångar`,
  case_studies: `Fallstudier`,
  preview_n_submit: `Förhandsgranska och skicka`,
  impact_measures: `Effektåtgärder`,
  the_company_has_requested_you_to_add_indicators_to_measure_the_progress_of_your_project: `Företaget har bett dig att lägga till indikatorer för att mäta framstegen i ditt projekt.`,
  general_indicators: `Allmänna indikatorer`,
  these_indicators_are_general_to_your_opportunity_or_entity_please_click_add_to_create_them: `Dessa indikatorer är generella för din möjlighet eller enhet. Klicka på "Lägg till" för att skapa dem.`,
  indicator: `Indikator`,
  required: `Nödvändig?`,
  target: `Mål`,
  final_title: `Slutlig`,
  status: `Status`,
  project_indicators: `Projektindikatorer`,
  the_indicators_below_are_linked_to_your_selected_objectives_and_outcomes_please_click_add_to_create_them: `Indikatorerna nedan är kopplade till dina valda mål och resultat. Klicka på "Lägg till" för att skapa dem.`,
  objective: `Mål`,
  outcome: `Resultat`,
  achieved: `Uppnådd`,
  your_absolute_impact_is: `Din absoluta inverkan är impactNumber`,
  your_relative_impact_is: `Din relativa påverkan är impactNumber`,
  case_studies_and_media: `Fallstudier och media`,
  case_studies_and_images_increase_the_likelihood_of_the_company_sharing_your_project_where_possible_please_share_a_case_study_and_at_least_one_image: `Fallstudier och bilder ökar sannolikheten för att företaget delar ditt projekt. Om möjligt, vänligen dela en fallstudie och minst en bild.`,
  add_case_study: `Lägg till fallstudie`,
  add_images: `Lägg till media`,
  case_study_name: `Fallstudienamn`,
  what_impact_did_your_project_have: `Vilken påverkan fick ditt projekt?`,
  share_a_quote_such_as_from_a_beneficiary: `Dela ett citat, till exempel från en förmånstagare`,
  quote_by: `Citat av`,
  share_a_photo_or_other_media: `Dela ett foto eller annat media`,
  what_happens_next_for_example_are_you_planning_to_develop_your_project_further: `Vad händer härnäst, planerar du till exempel att utveckla ditt projekt ytterligare?`,
  if_you_would_like_to_share_anything_else_with_the_company_please_use_the_box_below: `Om du vill dela något annat med företaget, använd rutan nedan`,
  the_company_has_requested_some_additional_information: `Företaget har begärt ytterligare information.`,
  content_agreement: `Innehållsavtal`,
  view_agreement: `Visa avtal`,
  application_agreement: `Ansökningsavtal`,
  send_message: `Skicka meddelande`,
  this_final_Report_is_for: `Denna slutrapport är för`,
  company_questions: `Företagsfrågor`,
  next_steps: `Nästa steg`,
  additional_details: `Ytterligare detaljer`,
  objectives_and_outcomes: `Mål och resultat`,
  planned: `Planerad`,
  actual: `Faktisk`,
  days: `dagar`,
  of_equivalent_value: `av motsvarande värde`,
  case_study: `Fallstudie`,
  includes_changes: `Inkluderar ändringar`,
  hundred_as_planned: `100% som planerat`,
  show_planned_efforts: `Visa planerade insatser`,
  final: `Slutlig`,
  support_awarded: `Stöd tilldelas`,
  password_reset_expired: `Lösenordsåterställning har löpt ut`,
  please_select_forgot_password_again_and_click_on_the_email_to_reset_your_password_within_fifteen_minutes: `Vänligen välj "Glömt lösenord" igen och klicka på e-postmeddelandet för att återställa ditt lösenord inom 15 minuter.`,
  please_check_check_your_spam_folder_if_the_email_is_not_immediately_visible: `Kontrollera din skräppostmapp om e-postmeddelandet inte är synligt direkt.`,
  request: `Begäran`,
  please_note_this_email_address_needs_to_match_the_address: `Observera: den här e-postadressen måste stämma överens med adressen som du fick din inbjudan till.`,
  an_access_email_has_sent_to: `Ett åtkomstmail har skickats till:`,
  you_can_close_this_tab: `Du kan stänga den här fliken.`,
  we_couldnt_find_your_email_address: `Vi kunde inte hitta din e-postadress. Se till att det är samma som din inbjudningsmail.`,
  the_feedback_portal_link_has_now_expired: `Länken till Feedbackportalen har nu upphört att gälla.`,
  please_contact_your_programme_administrator_if_you_still_require_access: `Kontakta din programadministratör om du fortfarande behöver åtkomst.`,
  verify: `Kontrollera`,
  the_email_address_entered_does_not_match_your_unique_link_please_ensure_it_is_the_same_as_your_invitation_email: `Den angivna e-postadressen matchar inte din unika länk. Se till att det är samma som din inbjudningsmail.`,
  email_entered: `E-post angett`,
  try_again: `Försök igen`,
  welcome_to_your_voting_panel: `Välkommen till din röstpanel!`,
  please_click_review_to_assess_each_application_and_then_cast_your_vote: `Klicka på "Granska" för att bedöma varje ansökan och lämna sedan din röst.`,
  please_enter_your_name: `Vänligen ange ditt namn`,
  registered_charity: `Registrerad välgörenhet`,
  charitable_company: `Välgörenhetsföretag`,
  community_interest_company: `Samhällsintresseföretag`,
  charitable_trust: `Välgörenhetsförtroende`,
  for_profit_company: `För vinstföretag`,
  academic_institution: `Akademisk institution`,
  government_linked_entity: `Regeringen kopplad enhet`,
  parish_or_community_council: `Församlings- eller kommunfullmäktige`,
  please_upload_a_copy_of_your_governing_document1: `Ladda upp en kopia av ditt styrande dokument`,
  please_upload_a_copy_of_your_governing_document2: `Ladda upp en kopia av ditt styrande dokument`,
  please_upload_a_copy_of_your_governing_document4: `Ladda upp en kopia av ditt styrande dokument`,
  insert_number: `Infoga nummer`,
  bring_the_project_to_life_share_pictures_of_what_you_will_be_changing_or_plan_to_achieve: `Väck projektet till liv. Dela bilder på vad du kommer att förändra eller planerar att uppnå.`,
  please_select_an_existing_user_or_invite_a_new_one: `Välj en befintlig användare eller bjud in en ny.`,
  country_af: `Afghanistan`,
  country_ax: `Åland`,
  country_al: `Albanien`,
  country_dz: `Algeriet`,
  country_as: `Amerikanska Samoa`,
  country_ad: `Andorra`,
  country_ao: `Angola`,
  country_ai: `Anguilla`,
  country_aq: `Antarktis`,
  country_ag: `Antigua och Barbuda`,
  country_ar: `Argentina`,
  country_am: `Armenien`,
  country_aw: `Aruba`,
  country_au: `Australien`,
  country_at: `Österrike`,
  country_az: `Azerbajdzjan`,
  country_bs: `Bahamas`,
  country_bh: `Bahrain`,
  country_bd: `Bangladesh`,
  country_bb: `Barbados`,
  country_by: `Belarus`,
  country_be: `Belgien`,
  country_bz: `Belize`,
  country_bj: `Benin`,
  country_bm: `Bermuda`,
  country_bt: `Bhutan`,
  country_bo: `Bolivia, plurinationell delstat`,
  country_bq: `Bonaire, Sint Eustatius och Saba`,
  country_ba: `Bosnien och Hercegovina`,
  country_bw: `Botswana`,
  country_bv: `Bouvetön`,
  country_br: `Brasilien`,
  country_io: `Brittiska territoriet i Indiska oceanen`,
  country_bn: `Brunei Darussalam`,
  country_bg: `Bulgarien`,
  country_bf: `Burkina Faso`,
  country_bi: `Burundi`,
  country_cv: `Cabo Verde`,
  country_kh: `Kambodja`,
  country_cm: `Kamerun`,
  country_ca: `Kanada`,
  country_ky: `Caymanöarna`,
  country_cf: `Centralafrikanska republiken`,
  country_td: `Tchad`,
  country_cl: `Chile`,
  country_cn: `Kina`,
  country_cx: `Julön`,
  country_cc: `Cocos (Keeling) Islands`,
  country_co: `Colombia`,
  country_km: `Komorerna`,
  country_cg: `Kongo`,
  country_cd: `Kongo, Demokratiska republiken`,
  country_ck: `Cooköarna`,
  country_cr: `Costa Rica`,
  country_ci: `Elfenbenskusten`,
  country_hr: `Kroatien`,
  country_cu: `Kuba`,
  country_cw: `Curaçao`,
  country_cy: `Cypern`,
  country_cz: `Tjeckien`,
  country_dk: `Danmark`,
  country_dj: `Djibouti`,
  country_dm: `Dominica`,
  country_do: `Dominikanska republiken`,
  country_ec: `Ecuador`,
  country_eg: `Egypten`,
  country_sv: `El Salvador`,
  country_gq: `Ekvatorialguinea`,
  country_er: `Eritrea`,
  country_ee: `Estland`,
  country_sz: `Eswatini`,
  country_et: `Etiopien`,
  country_fk: `Falklandsöarna (Malvinas)`,
  country_fo: `Färöarna`,
  country_fj: `Fiji`,
  country_fi: `Finland`,
  country_fr: `Frankrike`,
  country_gf: `Franska Guyana`,
  country_pf: `Franska Polynesien`,
  country_tf: `franska södra territorierna`,
  country_ga: `Gabon`,
  country_gm: `Gambia`,
  country_ge: `Georgien`,
  country_de: `Tyskland`,
  country_gh: `Ghana`,
  country_gi: `Gibraltar`,
  country_gr: `Grekland`,
  country_gl: `Grönland`,
  country_gd: `Grenada`,
  country_gp: `Guadeloupe`,
  country_gu: `Guam`,
  country_gt: `Guatemala`,
  country_gg: `Guernsey`,
  country_gn: `Guinea`,
  country_gw: `Guinea-Bissau`,
  country_gy: `Guyana`,
  country_ht: `Haiti`,
  country_hm: `Heard Island och McDonald Islands`,
  country_va: `Heliga stolen`,
  country_hn: `Honduras`,
  country_hk: `Hong Kong`,
  country_hu: `Ungern`,
  country_is: `Island`,
  country_in: `Indien`,
  country_id: `Indonesien`,
  country_ir: `Iran, Islamiska republiken`,
  country_iq: `Irak`,
  country_ie: `Irland`,
  country_im: `Isle of Man`,
  country_il: `Israel`,
  country_it: `Italien`,
  country_jm: `Jamaica`,
  country_jp: `Japan`,
  country_je: `Jersey`,
  country_jo: `Jordanien`,
  country_kz: `Kazakstan`,
  country_ke: `Kenya`,
  country_ki: `Kiribati`,
  country_kp: `Korea, Demokratiska folkrepubliken`,
  country_kr: `Korea, Republiken`,
  country_kw: `Kuwait`,
  country_kg: `Kirgizistan`,
  country_la: `Laos demokratiska republik`,
  country_lv: `Lettland`,
  country_lb: `Libanon`,
  country_ls: `Lesotho`,
  country_lr: `Liberia`,
  country_ly: `Libyen`,
  country_li: `Liechtenstein`,
  country_lt: `Litauen`,
  country_lu: `Luxemburg`,
  country_mo: `Macao`,
  country_mg: `Madagaskar`,
  country_mw: `Malawi`,
  country_my: `Malaysia`,
  country_mv: `Maldiverna`,
  country_ml: `Mali`,
  country_mt: `Malta`,
  country_mh: `Marshallöarna`,
  country_mq: `Martinique`,
  country_mr: `Mauretanien`,
  country_mu: `Mauritius`,
  country_yt: `Mayotte`,
  country_mx: `Mexiko`,
  country_fm: `Mikronesien, federerade stater av`,
  country_md: `Moldavien, Republiken`,
  country_mc: `Monaco`,
  country_mn: `mongoliet`,
  country_me: `Montenegro`,
  country_ms: `Montserrat`,
  country_ma: `Marocko`,
  country_mz: `Moçambique`,
  country_mm: `Myanmar`,
  country_na: `Namibia`,
  country_nr: `Nauru`,
  country_np: `Nepal`,
  country_nl: `Nederländerna, kungariket`,
  country_nc: `Nya Kaledonien`,
  country_nz: `Nya Zeeland`,
  country_ni: `Nicaragua`,
  country_ne: `Niger`,
  country_ng: `Nigeria`,
  country_nu: `Niue`,
  country_nf: `Norfolkön`,
  country_mk: `Nordmakedonien`,
  country_mp: `Nordmarianerna`,
  country_no: `Norge`,
  country_om: `oman`,
  country_pk: `Pakistan`,
  country_pw: `Palau`,
  country_ps: `Palestina, staten`,
  country_pa: `Panama`,
  country_pg: `Papua Nya Guinea`,
  country_py: `Paraguay`,
  country_pe: `Peru`,
  country_ph: `Filippinerna`,
  country_pn: `Pitcairn`,
  country_pl: `Polen`,
  country_pt: `Portugal`,
  country_pr: `Puerto Rico`,
  country_qa: `Qatar`,
  country_re: `Återförening`,
  country_ro: `Rumänien`,
  country_ru: `ryska federationen`,
  country_rw: `Rwanda`,
  country_bl: `Saint Barthélemy`,
  country_sh: `Saint Helena, Ascension och Tristan da Cunha`,
  country_kn: `Saint Kitts och Nevis`,
  country_lc: `Saint Lucia`,
  country_mf: `Saint Martin (franska delen)`,
  country_pm: `Saint Pierre och Miquelon`,
  country_vc: `Saint Vincent och Grenadinerna`,
  country_ws: `Samoa`,
  country_sm: `San Marino`,
  country_st: `Sao Tomé och Principe`,
  country_sa: `saudi-arabien`,
  country_sn: `Senegal`,
  country_rs: `Serbien`,
  country_sc: `Seychellerna`,
  country_sl: `Sierra Leone`,
  country_sg: `Singapore`,
  country_sx: `Sint Maarten (nederländska delen)`,
  country_sk: `Slovakien`,
  country_si: `Slovenien`,
  country_sb: `Salomonöarna`,
  country_so: `Somalia`,
  country_za: `Sydafrika`,
  country_gs: `South Georgia och South Sandwich Islands`,
  country_ss: `Sydsudan`,
  country_es: `Spanien`,
  country_lk: `Sri Lanka`,
  country_sd: `Sudan`,
  country_sr: `Surinam`,
  country_sj: `Svalbard och Jan Mayen`,
  country_se: `Sverige`,
  country_ch: `Schweiz`,
  country_sy: `Syrien Arabrepubliken`,
  country_tw: `Taiwan, provinsen Kina`,
  country_tj: `Tadzjikistan`,
  country_tz: `Tanzania, Förenade republiken`,
  country_th: `Thailand`,
  country_tl: `Östtimor`,
  country_tg: `Togo`,
  country_tk: `Tokelau`,
  country_to: `Tonga`,
  country_tt: `Trinidad och Tobago`,
  country_tn: `Tunisien`,
  country_tr: `Turkiet`,
  country_tm: `Turkmenistan`,
  country_tc: `Turks- och Caicosöarna`,
  country_tv: `Tuvalu`,
  country_ug: `Uganda`,
  country_ua: `Ukraina`,
  country_ae: `Förenade Arabemiraten`,
  country_gb: `Förenade kungariket Storbritannien och Nordirland`,
  country_us: `Amerikas förenta stater`,
  country_um: `Förenta staternas mindre avlägsna öar`,
  country_uy: `Uruguay`,
  country_uz: `Uzbekistan`,
  country_vu: `Vanuatu`,
  country_ve: `Venezuela, Bolivariska republiken`,
  country_vn: `Vietnam`,
  country_vg: `Jungfruöarna (brittiska)`,
  country_vi: `Jungfruöarna (USA)`,
  country_wf: `Wallis och Futuna`,
  country_eh: `Västsahara`,
  country_ye: `Jemen`,
  country_zm: `Zambia`,
  country_zw: `Zimbabwe`
  }

export default svLocale;
